import { isDefined } from '@sgme/fp';
import { type Type, type } from 'arktype';

import { arkScope } from '@/api/workspace/endpoints/arkConfig.ts';
import { logger } from '@/components/SgwtBootstrap/logger.ts';

export function validateArrayWith<T, X>(validator: Type<T, X>): Type<T[], X> {
  // @ts-expect-error Arktype pipe typing issue
  return arkScope
    .type('Array')
    .pipe((array) => {
      return array
        .map((el) => {
          const res = validator(el);
          if (res instanceof type.errors) {
            logger.logError('Invalid saved product data: {errors_s}', res.toString());
            return undefined;
          }
          return res;
        })
        .filter(isDefined);
    })
    .default(() => []);
}
